import React from "react";
import PropTypes from "prop-types";

const CalciteDropdown = ({ onBeforeClose, onBeforeOpen, onClose, onOpen, onSelect, ...props }) => {
  const dropdownRef = React.useRef(null);

  // on mount
  React.useEffect(() => {
    const dropdown = dropdownRef.current;

    const onBeforeCloseHandler = onBeforeClose;
    const onBeforeOpenHandler = onBeforeOpen;
    const onCloseHandler = onClose;
    const onOpenHandler = onOpen;
    const onSelectHandler = onSelect;

    dropdown.addEventListener("calciteDropdownBeforeClose", onBeforeCloseHandler);
    dropdown.addEventListener("calciteDropdownBeforeOpen", onBeforeOpenHandler);
    dropdown.addEventListener("calciteDropdownClose", onCloseHandler);
    dropdown.addEventListener("calciteDropdownOpen", onOpenHandler);
    dropdown.addEventListener("calciteDropdownSelect", onSelectHandler);

    // on unmount
    return () => {
      dropdown.removeEventListener("calciteDropdownBeforeClose", onBeforeCloseHandler);
      dropdown.removeEventListener("calciteDropdownBeforeOpen", onBeforeOpenHandler);
      dropdown.removeEventListener("calciteDropdownClose", onCloseHandler);
      dropdown.removeEventListener("calciteDropdownOpen", onOpenHandler);
      dropdown.removeEventListener("calciteDropdownSelect", onSelectHandler);
    };
  }, [onBeforeClose, onBeforeOpen, onClose, onOpen, onSelect]);

  return (
    <calcite-dropdown
      ref={dropdownRef}
      class={props.className}
      close-on-select-disabled={props.closeOnSelectDisabled || undefined}
      disabled={props.disabled || undefined}
      max-items={props.maxItems || undefined}
      open={props.open || undefined}
      overlay-positioning={props.overlayPositioning || undefined}
      placement={props.placement || undefined}
      scale={props.scale || undefined}
      type={props.type || undefined}
      width={props.width || undefined}
    >
      {props.children}
    </calcite-dropdown>
  );
};

CalciteDropdown.propTypes = {
  onBeforeClose: PropTypes.func,
  onBeforeOpen: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  onSelect: PropTypes.func,
  closeOnSelectDisabled: PropTypes.bool,
  disabled: PropTypes.bool,
  maxItems: PropTypes.number,
  open: PropTypes.bool,
  overlayPositioning: PropTypes.string,
  placement: PropTypes.string,
  scale: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default CalciteDropdown;
